// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: "test",
  production: false,
  development: false,
  test: true,
  url: "https://test-pendelportalen.stockholmstag.sj.se",
  loginRedirect: "https://test-pendelportalen.stockholmstag.sj.se/signin-oidc",
  messagesBaseUrl: "https://test-api.stockholmstag.sj.se/public/messagesapi",
  contactApiBaseUrl: "https://test-api.stockholmstag.sj.se/public/contactapi",
  alcolockApiBaseUrl: "https://test-api.stockholmstag.sj.se/public/drc/drivercompliance",
  alcolockApiVersion: "1",
  graphUrl: "https://graph.microsoft.com/v1.0",
  messagesApiVersion: "1",  
  getMessagesApiSuffix: "/api/v1/messages", 
  getToTMessagesApiSuffix: "/api/v1/messages/tot", 
  getAppMessagesApiSuffix: "/api/v1/messages/app", 
  createMessageApiSuffix: "/api/v1/messages", 
  createMessageVersionApiSuffix: "/api/v1/messages", 
  getMessagesByIdApiSuffix: "/api/v1/messages", 
  markMessageReadApiSuffix: "/api/v1/messages", 
  messagesScopes: "api://f782d600-f96c-42fd-85c2-fd4d7e1f1926/access_as_user",
  contactScopes: "api://10ed668a-47ab-4f96-8095-2d252e1db3a1/access_as_user",
  alcolockScopes: "7cf05aa3-2cb8-42e3-8772-e8715da7f141/.default",
  clientID: "7cf05aa3-2cb8-42e3-8772-e8715da7f141",
  tenantID: "2146c4ae-6471-40a8-b821-2774c8057963",
  loginUrl: "https://login.microsoftonline.com/",
  trainOnTimeAdminUrl: "https://test-pendeltag.stockholmstag.sj.se/admin",
  trainOrderBaseUrl: "https://test-api.stockholmstag.sj.se/public/trainorders",
  getTrainInformationsApiSuffix: "/api/v2/traininformations",
  trainOrderScopes: "api://6b8d6fe7-992c-4fb2-9353-05fb2364069b/access_as_user",
  driverDeviationBaseUrl: "https://test-api.stockholmstag.sj.se/public",
  driverDeviationApiVersion: "2",
  getDriverDeviationsApiSuffix: "/trainorders/api/v2/driverdeviations",
  resolveDeviationApiSuffix: "/trainorders/api/v2/driverdeviations",
  readWriteContactsGroups: ["9ec4358d-6488-409a-97b4-3f43a6505aba", "02dadc2b-1062-40f0-b858-9c4abab19a8c"],
  readWriteGroups: ["9ec4358d-6488-409a-97b4-3f43a6505aba"],
  trainOrderGroups: ["ca1d6f41-4b47-4d3c-81f7-b81ca112a448", "8e335f94-91cf-426b-865a-e57d2746077f", "dc3fc34d-2c33-4384-aaee-810fe5fc26bf", "65318c48-9a90-41d5-a8f9-543b0f945d6b", "9e683c0f-efc4-4a94-ba81-f3f88ace12da"],
  alcolockGroups: ["Michael.Nordquist@sj.se", "Awais.Muhammad@sj.se", "Salih.Sarihan@sj.se", "Stanislav.Olsson@sj.se", "PaIbrahim.Sanyang@sj.se"],
  driverDeviationGroups: ["Stanislav.Olsson@sj.se", "Roland.Colliander@sj.se", "Michael.Nordquist@sj.se", "Issa.Kobayashi@sj.se", "DGenaro.PeraltaPizarro@sj.se", "PaIbrahim.Sanyang@sj.se"]
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js';  // Included with Angular CLI.
